import {Component, Input, OnChanges, OnDestroy, SimpleChanges} from '@angular/core';
import {PointOptionsType} from 'highcharts';
import {Subject} from 'rxjs/internal/Subject';
import {MonitoringDetailsService} from '../../monitoring-details.service';
import {MetricType} from '../../../../../models-monitoring';
import {ChartPoint} from '../../../../../models';
import {VpnUsageService} from './vpn-usage.service';

@Component({
    selector: 'app-vpn-usage',
    templateUrl: './vpn-usage.component.html',
    styleUrls: ['./vpn-usage.component.scss']
})
export class VpnUsageComponent implements OnChanges, OnDestroy {


    @Input()
    metricId: number;

    @Input()
    metricType: MetricType;

    @Input()
    begin: Date;

    @Input()
    end: Date;

    @Input()
    resolution: number;

    @Input()
    serverId: number;

    dataSubject = new Subject<PointOptionsType[]>();

    chartPointList: ChartPoint[] = [];

    constructor(private service: VpnUsageService,
                private monitoringDetailsService: MonitoringDetailsService) {
        this.monitoringDetailsService.changePath('monitoring-details', 'vpn');
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.chartPointList = [];
        this.service.loadFromDbAndWebSocket(this.begin, this.end, this.metricType, this.metricId, this.serverId, this.resolution, this.chartPointList, this.dataSubject);
    }

    ngOnDestroy(): void {
        this.chartPointList = [];
        this.dataSubject = new Subject<PointOptionsType[]>();
        this.service.unSubscribe();
    }
}
